import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const CREATE = "product/create";
const GET = "product/get";
const GETALL = "product/getall";
const DELETE = "product/delete";
const UPDATE = "product/update";

const CREATE_ORDER = "productOrder/create";
const GET_ORDER = "productOrder/getall";
const UPDATE_ORDER = "productOrder/update";
const GET_BRAND_ORDER = "productOrder/getBrandOrder";
const ORDER_STATUS = "productOrder/orderStatus";
const ORDER_COUNT = "productOrder/getOderCount";

const ADD_ITEM = "ecomCart/addItem";
const GET_CART = "ecomCart/get";
const REMOVE_ITEM = "ecomCart/removeItem";
const UPDATE_CART = "ecomCart/updateCart";
const UPDATE_ADD = "ecomCart/updateAddress";

const ADD_BRAND = "brand/create";
const GET_BRAND = "brand/get";
const UPDATE_BRAND = "brand/update";
const DELETE_BRAND = "brand/delete";

const ADD_VENDOR = "vendor/addVendor";
const GET_ALL_VENDOR = "vendor/getAll";
const GET_VENDOR_BY_ADMIN = "vendor/getVendorByAdmin";
const GET_VENDOR_PRODUCT = "vendor/getVendorProducts";
const GET_VENDOR_ID = "vendor/getVendorById";
const UPDATE_VENDOR = "vendor/update";
const DELETE_VENDOR = "vendor/delete";

const ADD_URL = "url/create";
const GET_URL = "url/get";
const UPDATE_URL = "url/update";
const DELETE_URL = "url/delete";

export default {
  createProduct(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },

  getProduct(payload) {
    return Repository.post(transformRoute(GET), payload);
  },

  getAllProduct(payload) {
    return Repository.post(transformRoute(GETALL), payload);
  },
  updateCart(payload) {
    return Repository.post(transformRoute(UPDATE_CART), payload);
  },

  deleteProduct(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },

  updateProduct(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },

  createOrder(payload) {
    return Repository.post(transformRoute(CREATE_ORDER), payload);
  },

  getOrder(payload) {
    return Repository.get(transformRoute(GET_ORDER), { params: payload });
  },

  updateOrder(payload) {
    return Repository.post(transformRoute(UPDATE_ORDER), payload);
  },

  getBrandOrder(payload) {
    return Repository.post(transformRoute(GET_BRAND_ORDER), payload);
  },

  orderStatus(payload) {
    return Repository.post(transformRoute(ORDER_STATUS), payload);
  },

  orderCount(payload) {
    return Repository.get(transformRoute(ORDER_COUNT), { params: payload });
  },

  addItem(payload) {
    return Repository.post(transformRoute(ADD_ITEM), payload);
  },

  getCart(payload) {
    return Repository.get(transformRoute(GET_CART), { params: payload });
  },

  removeItem(payload) {
    return Repository.post(transformRoute(REMOVE_ITEM), payload);
  },

  updateAddress(payload) {
    return Repository.post(transformRoute(UPDATE_ADD), payload);
  },

  createBrand(payload) {
    return Repository.post(transformRoute(ADD_BRAND), payload);
  },

  getBrand(payload) {
    return Repository.get(transformRoute(GET_BRAND), { params: payload });
  },

  updateBrand(payload) {
    return Repository.post(transformRoute(UPDATE_BRAND), payload);
  },

  deleteBrand(payload) {
    return Repository.post(transformRoute(DELETE_BRAND), payload);
  },

  addVendor(payload) {
    return Repository.post(transformRoute(ADD_VENDOR), payload);
  },
  getAllVendor(payload) {
    return Repository.post(transformRoute(GET_ALL_VENDOR), payload);
  },
  getVendorByAdmin(payload) {
    return Repository.post(transformRoute(GET_VENDOR_BY_ADMIN), payload);
  },
  getVendorProduct(payload) {
    return Repository.post(transformRoute(GET_VENDOR_PRODUCT), payload);
  },
  getVendorById(payload) {
    return Repository.post(transformRoute(GET_VENDOR_ID), payload);
  },
  updateVendor(payload) {
    return Repository.post(transformRoute(UPDATE_VENDOR), payload);
  },
  deleteVendor(payload) {
    return Repository.post(transformRoute(DELETE_VENDOR), payload);
  },
  
  createUrl(payload) {
    return Repository.post(transformRoute(ADD_URL), payload);
  },

  getUrl(payload) {
    return Repository.get(transformRoute(GET_URL), { params: payload });
  },

  updateUrl(payload) {
    return Repository.post(transformRoute(UPDATE_URL), payload);
  },

  deleteUrl(payload) {
    return Repository.post(transformRoute(DELETE_URL), payload);
  },

};

const transformRoute = (route) => {
  return `/affiliate/${route}`;
};
